module.exports = __webpack_public_path__ + "static/media/pending.6d875638.svg";